export default __webpack_public_path__ + "static/media/066.f6876195.jpg";